module.exports = __webpack_public_path__ + "static/img/icon_bg1_vi.ac07f3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_bg1_vi.png
// module id = X00k
// module chunks = 0